<div class="diagram mt-5">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 587 552">
    <g id="Interior" transform="translate(-405 -109)">
      <g id="Group_1338" data-name="Group 1338">
        <path
          id="Path_89"
          data-name="Path 89"
          d="M817,159.977c-25.74-26.117-58.454-30.941-71.9-31.818-3.413-.223-5.565-.15-5.565-.15S696,126.494,663,159.977c0,0-17,170.656,7,259.224,0,0,6,15.121,70,15.121S810,419.2,810,419.2C834,330.633,817,159.977,817,159.977Z"
          transform="translate(-39 126.003)"
          fill="#ffe6b7"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.922"
        />
        <path
          id="Path_99"
          data-name="Path 99"
          d="M674.676,403.822V378.544s49.018-27.1,126.176,0v21.509s-.5,12.6-63.165,12.6C684.929,411.488,674.676,403.822,674.676,403.822Z"
          transform="translate(-37.834 144.866)"
          fill="#f8cf7f"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.444"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['dashboard'] || ''"
        [attr.data-name]="'interior.dashboard' | translate"
      >
        <rect
          id="Rectangle_38"
          data-name="Rectangle 38"
          width="131"
          height="24"
          rx="12"
          transform="translate(437 109)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 109)"
          class="parts"
          fill="#f9b22a"
        />
        <text
          id="_3.0"
          data-name="3.0"
          transform="translate(550 124)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Dashboard-2"
          data-name="Dashboard"
          transform="translate(474 125)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.dashboard' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow">
          <path
            id="Path_119"
            data-name="Path 119"
            d="M6302.611,1140.027,6185.723,979.656H6157"
            transform="translate(-5588.604 -858.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_120"
            data-name="Path 120"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(711 278)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Dashboard-3"
          data-name="Dashboard"
          d="M8274.612,1180l156.173.1v-15.685s-33.6-32.822-80.812-31.358a112.022,112.022,0,0,0-32,5.689c-27.175,9.689-42,25.669-42,25.669Z"
          transform="translate(-7652 -879)"
          fill="none"
          stroke="#707070"
          stroke-width="1.44"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['ac_parts']"
        [attr.data-name]="'interior.ac_parts' | translate"
        transform="translate(-1.336 -30.319)"
      >
        <rect
          id="Rectangle_38-2"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(826 144)"
          fill="#242e3a"
          opacity="0.07"
        />
        <g
          id="AC_Parts-2"
          data-name="AC Parts"
          transform="translate(721.336 304.319)"
          fill="#f0f7fe"
          stroke="#707070"
          stroke-width="1.5"
        >
          <path
            d="M0,0H23A18,18,0,0,1,41,18v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
            stroke="none"
          />
          <path
            d="M1.163.75h23A16.088,16.088,0,0,1,40.25,16.838v0a.413.413,0,0,1-.413.413H1.163a.413.413,0,0,1-.413-.413V1.162A.413.413,0,0,1,1.163.75Z"
            fill="none"
          />
        </g>
        <circle
          id="Ellipse_21-2"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 144)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-2"
          data-name="3.0"
          transform="translate(832 159)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="AC_Parts-3"
          data-name="AC Parts"
          transform="translate(857 160)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'interior.ac_parts' | translate }}</tspan>
        </text>
        <g id="Arrow-2" data-name="Arrow">
          <path
            id="Path_106"
            data-name="Path 106"
            d="M6151.188,1135.429l67.306-155.772h15.11"
            transform="translate(-5407.604 -823.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_54"
            data-name="Path 54"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(740 309)"
            fill="#696969"
          />
        </g>
        <path
          id="Path_104"
          data-name="Path 104"
          d="M819,301l-2,3v11"
          transform="translate(-40.158 137.819)"
          fill="#f9b22a"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['glove_box'] || ''"
        id="Glove_Box"
        [attr.data-name]="'interior.glove_box' | translate"
      >
        <path
          class="parts"
          id="Glove_Box-2"
          data-name="Glove Box"
          d="M758.5,170.921h40.221L798.5,180.5l-12,1-3-4h-9l-3,6h-19Z"
          transform="translate(-40.158 123.677)"
          fill="#f0f7fe"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-2"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(826 144)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-2"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 144)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-2"
          data-name="3.0"
          transform="translate(832 159)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Glove_Box-3"
          data-name="Glove Box"
          transform="translate(854 160)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.glove_box' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-2" data-name="Arrow">
          <path
            id="Path_106"
            data-name="Path 106"
            d="M6157,1123.027l61.494-143.371h15.11"
            transform="translate(-5407.604 -823.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_54"
            data-name="Path 54"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(746 296)"
            fill="#696969"
          />
        </g>
        <ellipse
          id="Ellipse_22"
          data-name="Ellipse 22"
          cx="6"
          cy="3.5"
          rx="6"
          ry="3.5"
          transform="translate(718.342 297.177)"
          fill="#ffce71"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.444"
        />
        <path
          id="Path_104"
          data-name="Path 104"
          d="M819,301l-2,3v11"
          transform="translate(-40.158 137.819)"
          fill="#f9b22a"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_door_panel'] || ''"
        [attr.data-name]="'interior.lft_frt_door_panel' | translate"
      >
        <path
          class="parts"
          id="LFT_FRT_Door_Panel-2"
          data-name="LFT FRT Door Panel"
          d="M660.78,183.164S675.5,208.5,671.5,260.5H657.247Z"
          transform="translate(-40.158 131.793)"
          fill="#ffce71"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.444"
        />
        <rect
          id="Rectangle_51"
          data-name="Rectangle 51"
          width="6"
          height="11.927"
          rx="1.79"
          transform="translate(625.202 350.759) rotate(-176.874)"
          fill="none"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="0.838"
        />
        <rect
          id="Rectangle_38-3"
          data-name="Rectangle 38"
          width="163"
          height="24"
          rx="12"
          transform="translate(405 319)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-3"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 319)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-3"
          data-name="3.0"
          transform="translate(550 334)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_FRT_Door_Panel-3"
          data-name="LFT FRT Door Panel"
          transform="translate(426 335)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.lft_frt_door_panel' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-3" data-name="Arrow">
          <path
            id="Path_131"
            data-name="Path 131"
            d="M6214.426,1011.738l-46.1-32.082H6157"
            transform="translate(-5591.604 -648.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_132"
            data-name="Path 132"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(620 360)"
            fill="#696969"
          />
        </g>
      </g>
      <g id="FRT_Seats" data-name="FRT Seats">
        <path
          id="Rectangle_38-4"
          data-name="Rectangle 38"
          d="M5,0H140a11,11,0,0,1,11,11V37a13,13,0,0,1-13,13H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
          transform="translate(417 354)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="FRT_Seats-2"
          data-name="FRT Seats"
          transform="translate(450 383)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'interior.frt_seats' | translate }}</tspan>
        </text>
        <g
          (click)="openCondition($event)"
          class="partGrp excellent"
          [id]="parts['frt_seats_left'] || ''"
          [attr.data-name]="('interior.frt_seats' | translate) + ' L'"
        >
          <path
            class="parts"
            id="FRT_Seats_L-2"
            data-name="FRT Seats L"
            d="M722.382,208H683.618c-3.655,0-6.618,2.555-6.618,5.706v43.766c0,3.151,2.963,5.706,6.618,5.706h6A1.988,1.988,0,0,0,687.5,265v5.832a1.988,1.988,0,0,0,2.118,1.826h26.764a1.988,1.988,0,0,0,2.118-1.826V265a1.988,1.988,0,0,0-2.118-1.826h6c3.655,0,6.618-2.555,6.618-5.706V213.706C729,210.555,726.037,208,722.382,208Z"
            transform="translate(-40.158 131.467)"
            fill="#ffce71"
            stroke="#696969"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <circle
            id="Ellipse_21-4"
            data-name="Ellipse 21"
            cx="12"
            cy="12"
            r="12"
            transform="translate(544 354)"
            fill="#f9b22a"
          />
          <text
            id="_3.0-4"
            data-name="3.0"
            transform="translate(550 369)"
            font-size="8"
            font-family="Roboto-Bold, Roboto"
            font-weight="700"
          >
            <tspan x="0" y="0" class="score">5.0</tspan>
          </text>
          <g id="L">
            <g
              id="Rectangle_52"
              data-name="Rectangle 52"
              transform="translate(519 357)"
              fill="#fff"
              stroke="#707070"
              stroke-width="1"
              opacity="0.328"
            >
              <rect width="22" height="20" stroke="none" />
              <rect x="0.5" y="0.5" width="21" height="19" fill="none" />
            </g>
            <text
              id="L-2"
              data-name="L"
              transform="translate(527 370)"
              fill="#242e3a"
              font-size="9"
              font-family="Roboto-Medium, Roboto"
              font-weight="500"
            >
              <tspan x="0" y="0">L</tspan>
            </text>
          </g>
        </g>
        <g
          (click)="openCondition($event)"
          class="partGrp excellent"
          [id]="parts['frt_seats_right'] || ''"
          [attr.data-name]="('interior.frt_seats' | translate) + ' R'"
        >
          <path
            class="parts"
            id="FRT_Seats_R-2"
            data-name="FRT Seats R"
            d="M793.382,208H754.618c-3.655,0-6.618,2.555-6.618,5.706v43.766c0,3.151,2.963,5.706,6.618,5.706h6A1.988,1.988,0,0,0,758.5,265v5.832a1.988,1.988,0,0,0,2.118,1.826h26.764a1.988,1.988,0,0,0,2.118-1.826V265a1.988,1.988,0,0,0-2.118-1.826h6c3.655,0,6.618-2.555,6.618-5.706V213.706C800,210.555,797.037,208,793.382,208Z"
            transform="translate(-40.158 131.467)"
            fill="#f8cf7f"
            stroke="#696969"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <circle
            id="Ellipse_21-5"
            data-name="Ellipse 21"
            cx="12"
            cy="12"
            r="12"
            transform="translate(544 379)"
            fill="#f9b22a"
          />
          <text
            id="_3.0-5"
            data-name="3.0"
            transform="translate(550 394)"
            font-size="8"
            font-family="Roboto-Bold, Roboto"
            font-weight="700"
          >
            <tspan x="0" y="0" class="score">5.0</tspan>
          </text>
          <g id="R">
            <g
              id="Rectangle_53"
              data-name="Rectangle 53"
              transform="translate(519 382)"
              fill="#fff"
              stroke="#707070"
              stroke-width="1"
              opacity="0.328"
            >
              <rect width="22" height="20" stroke="none" />
              <rect x="0.5" y="0.5" width="21" height="19" fill="none" />
            </g>
            <text
              id="R-2"
              data-name="R"
              transform="translate(527 395)"
              fill="#242e3a"
              font-size="9"
              font-family="Roboto-Medium, Roboto"
              font-weight="500"
            >
              <tspan x="0" y="0">R</tspan>
            </text>
          </g>
        </g>
        <g class="arrow" id="Arrow-4" data-name="Arrow">
          <path
            id="Path_133"
            data-name="Path 133"
            d="M6244.88,979.656H6157"
            transform="translate(-5591.604 -601.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_134"
            data-name="Path 134"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(650 375)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['carpets'] || ''"
        [attr.data-name]="'interior.carpets' | translate"
      >
        <rect
          id="Rectangle_38-5"
          data-name="Rectangle 38"
          width="131"
          height="24"
          rx="12"
          transform="translate(437 604)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-6"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 604)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-6"
          data-name="3.0"
          transform="translate(550 619)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Carpets-2"
          data-name="Carpets"
          transform="translate(490 619)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.carpets' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['smoking_package'] || ''"
        [attr.data-name]="'interior.smoking_pkg' | translate"
      >
        <rect
          id="Rectangle_38-6"
          data-name="Rectangle 38"
          width="116"
          height="24"
          rx="12"
          transform="translate(826 179)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-7"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 179)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-7"
          data-name="3.0"
          transform="translate(832 194)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Smoking_PKG-2"
          data-name="Smoking PKG"
          transform="translate(854 195)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.smoking_pkg' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['ceiling'] || ''"
        [attr.data-name]="'interior.ceiling' | translate"
      >
        <rect
          id="Rectangle_38-7"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(826 214)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-8"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 214)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-8"
          data-name="3.0"
          transform="translate(832 229)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Ceiling-2"
          data-name="Ceiling"
          transform="translate(854 230)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.ceiling' | translate }}
          </tspan>
        </text>
      </g>

      <!-- <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['general_condition'] || ''"
        [attr.data-name]="'interior.general_condition' | translate"
      >
        <rect
          id="Rectangle_38-8"
          data-name="Rectangle 38"
          width="142"
          height="24"
          rx="12"
          transform="translate(826 249)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-9"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 249)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-9"
          data-name="3.0"
          transform="translate(832 264)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="General_Condition-2"
          data-name="General Condition"
          transform="translate(854 265)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ "interior.general_condition" | translate }}
          </tspan>
        </text>
      </g> -->

      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['n_th_row_seat'] || ''"
        [attr.data-name]="'interior.nth_row_seat' | translate"
      >
        <rect
          id="Rectangle_38-9"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(826 546)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-10"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 546)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-10"
          data-name="3.0"
          transform="translate(832 561)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="nth_Row_Seat-2"
          data-name="nth Row Seat"
          transform="translate(854 562)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          {{ 'interior.nth_row_seat' | translate }}
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['other_1'] || ''"
        [attr.data-name]="'interior.other_1' | translate"
      >
        <rect
          id="Rectangle_38-10"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(826 582)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-11"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 582)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-11"
          data-name="3.0"
          transform="translate(832 597)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Other_1-2"
          data-name="Other 1"
          transform="translate(854 598)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.other_1' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['other_2'] || ''"
        [attr.data-name]="'interior.other_2' | translate"
      >
        <rect
          id="Rectangle_38-11"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(826 618)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-12"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 618)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-12"
          data-name="3.0"
          transform="translate(832 633)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Other_2-2"
          data-name="Other 2"
          transform="translate(854 634)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.other_2' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['entertainment_system'] || ''"
        [attr.data-name]="'interior.entertainment_system' | translate"
      >
        <rect
          class="parts"
          id="Entertainment_System-2"
          data-name="Entertainment System"
          width="22"
          height="11"
          rx="2.34"
          transform="translate(687.342 314.612)"
          fill="#eff7ff"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-12"
          data-name="Rectangle 38"
          width="166"
          height="24"
          rx="12"
          transform="translate(826 289)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-13"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 289)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-13"
          data-name="3.0"
          transform="translate(832 304)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Entertainment_System-3"
          data-name="Entertainment System"
          transform="translate(854 305)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.entertainment_system' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-5" data-name="Arrow">
          <path
            id="Path_108"
            data-name="Path 108"
            d="M6157,992.027l96.013-12.371H6276.6"
            transform="translate(-5450.604 -678.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_107"
            data-name="Path 107"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(703 310)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['guages'] || ''"
        [attr.data-name]="'interior.gauges' | translate"
      >
        <path
          class="parts"
          id="Gauges-2"
          data-name="Gauges"
          d="M675.5,183.5h50s2-21-25-21S675.5,183.5,675.5,183.5Z"
          transform="translate(-40.158 117.598)"
          fill="none"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.444"
        />
        <rect
          id="Rectangle_38-13"
          data-name="Rectangle 38"
          width="101"
          height="24"
          rx="12"
          transform="translate(467 179)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-14"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 179)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-14"
          data-name="3.0"
          transform="translate(550 194)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Gauges-3"
          data-name="Gauges"
          transform="translate(491 195)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.gauges' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-6" data-name="Arrow">
          <path
            id="Path_123"
            data-name="Path 123"
            d="M6254.692,1083.656l-78.422-104H6157"
            transform="translate(-5591.604 -787.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_124"
            data-name="Path 124"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(660 293)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['air_bag'] || ''"
        [attr.data-name]="'interior.air_bag' | translate"
      >
        <ellipse
          class="parts"
          id="Air_Bag-2"
          data-name="Air Bag"
          cx="20.5"
          cy="6.5"
          rx="20.5"
          ry="6.5"
          transform="translate(640.342 317.898)"
          fill="#eff7ff"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-14"
          data-name="Rectangle 38"
          width="94"
          height="24"
          rx="12"
          transform="translate(474 249)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-15"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 249)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-15"
          data-name="3.0"
          transform="translate(550 264)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Air_Bag-3"
          data-name="Air Bag"
          transform="translate(493 264)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.air_bag' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-7" data-name="Arrow">
          <path
            id="Path_127"
            data-name="Path 127"
            d="M6251.6,1042.656l-75.943-63H6157"
            transform="translate(-5591.604 -718.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_128"
            data-name="Path 128"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(657 321)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_door_panel'] || ''"
        [attr.data-name]="'interior.lft_rr_door_panel' | translate"
      >
        <path
          class="parts"
          id="LFT_RR_Door_Panel-2"
          data-name="LFT RR Door Panel"
          d="M657.247,263.314S670.5,260.5,670.5,268.5v54l-11.795,2.25Z"
          transform="translate(-40.158 131.793)"
          fill="#f8cf7f"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.444"
        />
        <rect
          id="rectangle."
          width="6"
          height="17"
          rx="2.135"
          transform="translate(623.846 447.618) rotate(179)"
          fill="none"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-15"
          data-name="Rectangle 38"
          width="163"
          height="24"
          rx="12"
          transform="translate(405 474)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-16"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 474)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-16"
          data-name="3.0"
          transform="translate(550 489)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_RR_Door_Panel-3"
          data-name="LFT RR Door Panel"
          transform="translate(432 490)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.lft_rr_door_panel' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-8" data-name="Arrow">
          <path
            id="Path_137"
            data-name="Path 137"
            d="M6214.6,979.656l-46.242,44.711H6157"
            transform="translate(-5591.604 -537.286)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_138"
            data-name="Path 138"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(620 439)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_fr_door_panel'] || ''"
        [attr.data-name]="'interior.rht_frt_door_panel' | translate"
      >
        <path
          class="parts"
          id="RHT_FRT_Door_Panel-2"
          data-name="RHT FRT Door Panel"
          d="M819.656,183.164s-14.72,25.336-10.72,77.336h14.253Z"
          transform="translate(-40.158 131.793)"
          fill="#f9b22a"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.444"
        />
        <rect
          id="Rectangle_49"
          data-name="Rectangle 49"
          width="6"
          height="11.927"
          rx="1.79"
          transform="translate(774.188 338.85) rotate(-3.126)"
          fill="none"
          stroke="#000"
          stroke-miterlimit="10"
          stroke-width="0.838"
        />
        <rect
          id="Rectangle_38-16"
          data-name="Rectangle 38"
          width="158"
          height="24"
          rx="12"
          transform="translate(826 384)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-17"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 384)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-17"
          data-name="3.0"
          transform="translate(832 399)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_FRT_Door_Panel-3"
          data-name="RHT FRT Door Panel"
          transform="translate(854 400)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.rht_frt_door_panel' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-9" data-name="Arrow">
          <path
            id="Path_112"
            data-name="Path 112"
            d="M6157,979.656l44.007,19.968h10.813"
            transform="translate(-5380.604 -603.286)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_111"
            data-name="Path 111"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(773 373)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['3rd_row_seat'] || ''"
        [attr.data-name]="'interior.3rd_row_seat' | translate"
      >
        <g class="parts" id="_3rd_Row_Seat-2" data-name="3rd Row Seat">
          <path
            id="Path_318"
            data-name="Path 318"
            d="M722.382,289H683.618c-3.655,0-6.618,1.649-6.618,3.684v28.259c0,2.035,2.963,3.684,6.618,3.684h6c-1.17,0-2.118.528-2.118,1.179v3.765c0,.651.948,1.179,2.118,1.179h26.764c1.17,0,2.118-.528,2.118-1.179v-3.765c0-.651-.948-1.179-2.118-1.179h6c3.655,0,6.618-1.649,6.618-3.684V292.684C729,290.649,726.037,289,722.382,289Z"
            transform="translate(-40.158 177.463)"
            fill="none"
            stroke="#696969"
            stroke-miterlimit="10"
            stroke-width="1.788"
          />
          <path
            id="Path_319"
            data-name="Path 319"
            d="M793.382,289H754.618c-3.655,0-6.618,1.649-6.618,3.684v28.259c0,2.035,2.963,3.684,6.618,3.684h6c-1.17,0-2.118.528-2.118,1.179v3.765c0,.651.948,1.179,2.118,1.179h26.764c1.17,0,2.118-.528,2.118-1.179v-3.765c0-.651-.948-1.179-2.118-1.179h6c3.655,0,6.618-1.649,6.618-3.684V292.684C800,290.649,797.037,289,793.382,289Z"
            transform="translate(-40.158 177.463)"
            fill="none"
            stroke="#696969"
            stroke-miterlimit="10"
            stroke-width="1.788"
          />
        </g>
        <rect
          id="Rectangle_74"
          data-name="Rectangle 74"
          width="12"
          height="5"
          rx="1.033"
          transform="translate(656.342 505)"
          fill="#f9b22a"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.444"
        />
        <rect
          id="Rectangle_75"
          data-name="Rectangle 75"
          width="12"
          height="5"
          rx="1.033"
          transform="translate(728.342 505)"
          fill="#f9b22a"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.444"
        />
        <rect
          id="Rectangle_38-17"
          data-name="Rectangle 38"
          width="131"
          height="24"
          rx="12"
          transform="translate(437 569)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-18"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 569)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-18"
          data-name="3.0"
          transform="translate(550 584)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="_3rd_Row_Seat-3"
          data-name="3rd Row Seat"
          transform="translate(461 584)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.3rd_row_seat' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-10" data-name="Arrow">
          <path
            id="Path_159"
            data-name="Path 159"
            d="M6251.6,979.656l-75.943,102.082H6157"
            transform="translate(-5589.604 -500.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_158"
            data-name="Path 158"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(660 476)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_view_mirror'] || ''"
        [attr.data-name]="'interior.rr_view_mirror' | translate"
      >
        <path
          class="parts"
          id="RR_View_Mirror-2"
          data-name="RR View Mirror"
          d="M734.5,158.5v-6h6v6h8l5,6h-31l5-6Z"
          transform="translate(-40.158 123.677)"
          fill="none"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.444"
        />
        <rect
          id="Rectangle_38-18"
          data-name="Rectangle 38"
          width="141"
          height="24"
          rx="12"
          transform="translate(427 144)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-19"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 144)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-19"
          data-name="3.0"
          transform="translate(550 159)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RR_View_Mirror-3"
          data-name="RR View Mirror"
          transform="translate(452 160)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.rr_view_mirror' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-11" data-name="Arrow">
          <path
            id="Path_121"
            data-name="Path 121"
            d="M6289,1104.656l-105.962-125H6157"
            transform="translate(-5591.604 -820.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_122"
            data-name="Path 122"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(694 281)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['console'] || ''"
        [attr.data-name]="'interior.console' | translate"
      >
        <rect
          class="parts"
          id="Console-2"
          data-name="Console"
          width="13"
          height="24"
          rx="2.583"
          transform="translate(691.342 343.237)"
          fill="#f0f7fe"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-19"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(826 325)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-20"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 324)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-20"
          data-name="3.0"
          transform="translate(832 339)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Console-3"
          data-name="Console"
          transform="translate(854 340)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.console' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-12" data-name="Arrow">
          <path
            id="Path_109"
            data-name="Path 109"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(695 357)"
            fill="#696969"
          />
          <path
            id="Path_110"
            data-name="Path 110"
            d="M6155.458,1004.023l103.173-24.367H6283.6"
            transform="translate(-5457.604 -643.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_door_panel'] || ''"
        [attr.data-name]="'interior.rht_rr_door_panel' | translate"
      >
        <path
          class="parts"
          id="RHT_RR_Door_Panel-2"
          data-name="RHT RR Door Panel"
          d="M823.189,263.314s-13.253-2.814-13.253,5.186v54l11.794,2.25Z"
          transform="translate(-40.158 131.793)"
          fill="#f9b22a"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.444"
        />
        <rect
          id="Rectangle_48"
          data-name="Rectangle 48"
          width="6"
          height="17"
          rx="2.135"
          transform="translate(776.906 430.493) rotate(3.766)"
          fill="none"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <rect
          id="Rectangle_38-20"
          data-name="Rectangle 38"
          width="161"
          height="24"
          rx="12"
          transform="translate(826 474)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-21"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 474)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-21"
          data-name="3.0"
          transform="translate(832 489)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_RR_Door_Panel-3"
          data-name="RHT RR Door Panel"
          transform="translate(854 490)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.rht_rr_door_panel' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-13" data-name="Arrow">
          <path
            id="Path_116"
            data-name="Path 116"
            d="M6157,979.656l44.007,43.629h10.813"
            transform="translate(-5380.604 -537.286)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_115"
            data-name="Path 115"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(775 440)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['shift_knob'] || ''"
        [attr.data-name]="'interior.shift_knob' | translate"
      >
        <rect
          id="Rectangle_38-21"
          data-name="Rectangle 38"
          width="110"
          height="24"
          rx="12"
          transform="translate(458 284)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-22"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 284)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-22"
          data-name="3.0"
          transform="translate(550 299)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Shift_Knob-2"
          data-name="Shift Knob"
          transform="translate(476 300)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.shift_knob' | translate }}
          </tspan>
        </text>
        <rect
          class="parts"
          id="Shift_Knob-3"
          data-name="Shift Knob"
          width="13"
          height="11"
          rx="2.583"
          transform="translate(691.342 343.237)"
          fill="#f0f7fe"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <g class="arrow" id="Arrow-14" data-name="Arrow">
          <path
            id="Path_129"
            data-name="Path 129"
            d="M6286.6,1033.656l-104.039-54H6157"
            transform="translate(-5589.604 -684.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_130"
            data-name="Path 130"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(695 346)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_arm_rest'] || ''"
        [attr.data-name]="'interior.rr_armrest' | translate"
      >
        <rect
          class="parts"
          id="RR_Armrest-2"
          data-name="RR Armrest"
          width="13"
          height="71.5"
          rx="2.916"
          transform="translate(691.842 429.451)"
          fill="none"
          stroke="#696969"
          stroke-miterlimit="10"
          stroke-width="1.444"
        />
        <rect
          id="Rectangle_38-22"
          data-name="Rectangle 38"
          width="116"
          height="24"
          rx="12"
          transform="translate(826 510)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-23"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 510)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-23"
          data-name="3.0"
          transform="translate(832 525)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RR_Armrest-3"
          data-name="RR Armrest"
          transform="translate(854 526)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.rr_armrest' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-15" data-name="Arrow">
          <path
            id="Path_114"
            data-name="Path 114"
            d="M7187.4,1289l110.846,73h15.042"
            transform="translate(-6488 -840)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_113"
            data-name="Path 113"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(696 446)"
            fill="#696969"
          />
        </g>
      </g>
      <g id="RR_Seats" data-name="RR Seats">
        <path
          id="Rectangle_38-23"
          data-name="Rectangle 38"
          d="M6,0H119a12,12,0,0,1,12,12V37a13,13,0,0,1-13,13H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z"
          transform="translate(437 509)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Seats-2"
          data-name="RR Seats"
          transform="translate(455 538)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.rr_seats' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-16" data-name="Arrow">
          <path
            id="Path_139"
            data-name="Path 139"
            d="M6251.6,979.656l-75.943,102.082H6157"
            transform="translate(-5589.604 -545.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_140"
            data-name="Path 140"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(659 431)"
            fill="#696969"
          />
        </g>
        <g
          (click)="openCondition($event)"
          class="partGrp excellent"
          [id]="parts['rr_seats_left'] || ''"
          [attr.data-name]="('interior.rr_seats' | translate) + ' L'"
        >
          <path
            class="parts"
            id="RR_Seats_L-2"
            data-name="RR Seats L"
            d="M722.382,289H683.618c-3.655,0-6.618,1.671-6.618,3.732v28.628c0,2.061,2.963,3.732,6.618,3.732h6c-1.17,0-2.118.535-2.118,1.194V330.1c0,.66.948,1.194,2.118,1.194h26.764c1.17,0,2.118-.535,2.118-1.194v-3.815c0-.66-.948-1.194-2.118-1.194h6c3.655,0,6.618-1.671,6.618-3.732V292.732C729,290.671,726.037,289,722.382,289Z"
            transform="translate(-40.158 125.246)"
            fill="none"
            stroke="#696969"
            stroke-miterlimit="10"
            stroke-width="1.788"
          />
          <rect
            id="Rectangle_45"
            data-name="Rectangle 45"
            width="12"
            height="5"
            rx="1.033"
            transform="translate(656.342 452.735)"
            fill="#f9b22a"
            stroke="#696969"
            stroke-miterlimit="10"
            stroke-width="1.444"
          />
          <circle
            id="Ellipse_21-24"
            data-name="Ellipse 21"
            cx="12"
            cy="12"
            r="12"
            transform="translate(544 509)"
            fill="#f9b22a"
          />
          <text
            id="_3.0-24"
            data-name="3.0"
            transform="translate(550 524)"
            font-size="8"
            font-family="Roboto-Bold, Roboto"
            font-weight="700"
          >
            <tspan x="0" y="0" class="score">5.0</tspan>
          </text>
          <g id="L-3" data-name="L">
            <g
              id="Rectangle_56"
              data-name="Rectangle 56"
              transform="translate(519 513)"
              fill="#fff"
              stroke="#707070"
              stroke-width="1"
              opacity="0.328"
            >
              <rect width="22" height="20" stroke="none" />
              <rect x="0.5" y="0.5" width="21" height="19" fill="none" />
            </g>
            <text
              id="L-4"
              data-name="L"
              transform="translate(527 526)"
              fill="#242e3a"
              font-size="9"
              font-family="Roboto-Medium, Roboto"
              font-weight="500"
            >
              <tspan x="0" y="0">L</tspan>
            </text>
          </g>
        </g>
        <g
          (click)="openCondition($event)"
          class="partGrp excellent"
          [id]="parts['rr_seats_right'] || ''"
          [attr.data-name]="('interior.rr_seats' | translate) + ' R'"
        >
          <path
            class="parts"
            id="RR_Seats_R-2"
            data-name="RR Seats R"
            d="M793.382,289H754.618c-3.655,0-6.618,1.671-6.618,3.732v28.628c0,2.061,2.963,3.732,6.618,3.732h6c-1.17,0-2.118.535-2.118,1.194V330.1c0,.66.948,1.194,2.118,1.194h26.764c1.17,0,2.118-.535,2.118-1.194v-3.815c0-.66-.948-1.194-2.118-1.194h6c3.655,0,6.618-1.671,6.618-3.732V292.732C800,290.671,797.037,289,793.382,289Z"
            transform="translate(-40.158 125.246)"
            fill="none"
            stroke="#696969"
            stroke-miterlimit="10"
            stroke-width="1.788"
          />
          <rect
            id="Rectangle_46"
            data-name="Rectangle 46"
            width="12"
            height="5"
            rx="1.033"
            transform="translate(728.342 452.735)"
            fill="#f9b22a"
            stroke="#696969"
            stroke-miterlimit="10"
            stroke-width="1.444"
          />
          <circle
            id="Ellipse_21-25"
            data-name="Ellipse 21"
            cx="12"
            cy="12"
            r="12"
            transform="translate(544 534)"
            fill="#f9b22a"
          />
          <text
            id="_3.0-25"
            data-name="3.0"
            transform="translate(550 549)"
            font-size="8"
            font-family="Roboto-Bold, Roboto"
            font-weight="700"
          >
            <tspan x="0" y="0" class="score">5.0</tspan>
          </text>
          <g id="R-3" data-name="R">
            <g
              id="Rectangle_57"
              data-name="Rectangle 57"
              transform="translate(519 536)"
              fill="#fff"
              stroke="#707070"
              stroke-width="1"
              opacity="0.328"
            >
              <rect width="22" height="20" stroke="none" />
              <rect x="0.5" y="0.5" width="21" height="19" fill="none" />
            </g>
            <text
              id="R-4"
              data-name="R"
              transform="translate(526 549)"
              fill="#242e3a"
              font-size="9"
              font-family="Roboto-Medium, Roboto"
              font-weight="500"
            >
              <tspan x="0" y="0">R</tspan>
            </text>
          </g>
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['tool__jack'] || ''"
        [attr.data-name]="'interior.tools_jacks' | translate"
      >
        <rect
          id="Rectangle_38-24"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(707 637)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-26"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(707 637)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-26"
          data-name="3.0"
          transform="translate(713 652)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Tools_Jacks-2"
          data-name="Tools/Jacks"
          transform="translate(734 653)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.tools_jacks' | translate }}
          </tspan>
        </text>
        <path
          class="parts"
          id="Tools_Jacks-3"
          data-name="Tools/Jacks"
          d="M314.847,527.073H303.494v-4.126a.761.761,0,0,0-.761-.76H290.815a.761.761,0,0,0-.761.76v4.126h-9.174a2.247,2.247,0,0,0-2.247,2.247v15.53a2.247,2.247,0,0,0,2.247,2.247h33.966a2.247,2.247,0,0,0,2.247-2.247V529.32A2.247,2.247,0,0,0,314.847,527.073Z"
          transform="translate(394.693 -0.187)"
          fill="#ffe6b7"
          stroke="#646464"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <g class="arrow" id="Arrow-17" data-name="Arrow">
          <path
            id="Path_550"
            data-name="Path 550"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(691 536)"
            fill="#696969"
          />
          <path
            id="Path_551"
            data-name="Path 551"
            d="M8346,1437l58,71.855V1535"
            transform="translate(-7652 -898)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['spare_wheel'] || ''"
        [attr.data-name]="'interior.spare_wheel' | translate"
      >
        <rect
          id="Rectangle_38-25"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(587 637)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-27"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(587 637)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-27"
          data-name="3.0"
          transform="translate(593 652)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Spare_Wheel-2"
          data-name="Spare Wheel"
          transform="translate(614 653)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.spare_wheel' | translate }}
          </tspan>
        </text>
        <ellipse
          class="parts"
          id="Spare_Wheel-3"
          data-name="Spare Wheel"
          cx="10.29"
          cy="10.012"
          rx="10.29"
          ry="10.012"
          transform="translate(647.018 526.886)"
          fill="#ffe6b7"
          stroke="#646766"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <g class="arrow" id="Arrow-18" data-name="Arrow">
          <path
            id="Path_553"
            data-name="Path 553"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(654 534)"
            fill="#696969"
          />
          <path
            id="Path_552"
            data-name="Path 552"
            d="M8361.5,1437l-15.5,71.855V1535"
            transform="translate(-7704.5 -899)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['steering_wheel'] || ''"
        [attr.data-name]="'interior.steering_wheel' | translate"
      >
        <rect
          id="Rectangle_38-26"
          data-name="Rectangle 38"
          width="131"
          height="24"
          rx="12"
          transform="translate(437 214)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-28"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 214)"
          fill="#f9b22a"
        />
        <g class="arrow" id="Arrow-19" data-name="Arrow">
          <path
            id="Path_125"
            data-name="Path 125"
            d="M6254.291,1064.063l-78.021-84.407H6157"
            transform="translate(-5591.604 -754.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_126"
            data-name="Path 126"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(659 306)"
            fill="#696969"
          />
        </g>
        <text
          id="_3.0-28"
          data-name="3.0"
          transform="translate(550 229)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Steering_Wheel-2"
          data-name="Steering Wheel"
          transform="translate(451 230)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.steering_wheel' | translate }}
          </tspan>
        </text>
        <g
          class="parts"
          id="Steering_Wheel-3"
          data-name="Steering Wheel"
          transform="translate(635 304)"
          fill="none"
          stroke="#707070"
          stroke-width="1.4"
        >
          <rect width="51" height="5" rx="2.5" stroke="none" />
          <rect x="0.7" y="0.7" width="49.6" height="3.6" rx="1.8" fill="none" />
        </g>
      </g>
      <g id="Seat_Belts" data-name="Seat Belts">
        <path
          id="Rectangle_38-27"
          data-name="Rectangle 38"
          d="M5,0H119a12,12,0,0,1,12,12V38a11,11,0,0,1-11,11H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
          transform="translate(437 414)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Seat_Belts-2"
          data-name="Seat Belts"
          transform="translate(452 443)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'interior.seat_belts' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-20" data-name="Arrow">
          <path
            id="Path_135"
            data-name="Path 135"
            d="M6221,979.656l-51.376,42H6157"
            transform="translate(-5589 -583.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_136"
            data-name="Path 136"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(631 392)"
            fill="#696969"
          />
        </g>
        <g
          (click)="openCondition($event)"
          class="partGrp excellent"
          [id]="parts['seat_belts_left'] || ''"
          [attr.data-name]="('interior.seat_belts' | translate) + ' L'"
        >
          <circle
            id="Ellipse_21-29"
            data-name="Ellipse 21"
            cx="12"
            cy="12"
            r="12"
            transform="translate(544 414)"
            fill="#f9b22a"
          />
          <text
            id="_3.0-29"
            data-name="3.0"
            transform="translate(550 429)"
            font-size="8"
            font-family="Roboto-Bold, Roboto"
            font-weight="700"
          >
            <tspan x="0" y="0" class="score">5.0</tspan>
          </text>
          <g id="L-5" data-name="L">
            <g
              id="Rectangle_55"
              data-name="Rectangle 55"
              transform="translate(519 417)"
              fill="#fff"
              stroke="#707070"
              stroke-width="1"
              opacity="0.328"
            >
              <rect width="22" height="20" stroke="none" />
              <rect x="0.5" y="0.5" width="21" height="19" fill="none" />
            </g>
            <text
              id="L-6"
              data-name="L"
              transform="translate(527 430)"
              fill="#242e3a"
              font-size="9"
              font-family="Roboto-Medium, Roboto"
              font-weight="500"
            >
              <tspan x="0" y="0">L</tspan>
            </text>
          </g>
          <g
            class="parts"
            id="Seat_Belts_L-2"
            data-name="Seat Belts L"
            transform="translate(632 382)"
            fill="none"
            stroke="#707070"
            stroke-width="1"
          >
            <rect width="4" height="10" rx="1" stroke="none" />
            <rect x="0.5" y="0.5" width="3" height="9" rx="0.5" fill="none" />
          </g>
        </g>
        <g
          (click)="openCondition($event)"
          class="partGrp excellent"
          [id]="parts['seat_belts_right'] || ''"
          [attr.data-name]="('interior.seat_belts' | translate) + ' R'"
        >
          <circle
            id="Ellipse_21-30"
            data-name="Ellipse 21"
            cx="12"
            cy="12"
            r="12"
            transform="translate(544 439)"
            fill="#f9b22a"
          />
          <text
            id="_3.0-30"
            data-name="3.0"
            transform="translate(550 454)"
            font-size="8"
            font-family="Roboto-Bold, Roboto"
            font-weight="700"
          >
            <tspan x="0" y="0" class="score">5.0</tspan>
          </text>
          <g id="R-5" data-name="R">
            <g
              id="Rectangle_54"
              data-name="Rectangle 54"
              transform="translate(519 441)"
              fill="#fff"
              stroke="#707070"
              stroke-width="1"
              opacity="0.328"
            >
              <rect width="22" height="20" stroke="none" />
              <rect x="0.5" y="0.5" width="21" height="19" fill="none" />
            </g>
            <text
              id="R-6"
              data-name="R"
              transform="translate(526 454)"
              fill="#242e3a"
              font-size="9"
              font-family="Roboto-Medium, Roboto"
              font-weight="500"
            >
              <tspan x="0" y="0">R</tspan>
            </text>
          </g>
          <g
            class="parts"
            id="Seat_Belts_R-2"
            data-name="Seat Belts R"
            transform="translate(764 382)"
            fill="none"
            stroke="#707070"
            stroke-width="1"
          >
            <rect width="4" height="10" rx="1" stroke="none" />
            <rect x="0.5" y="0.5" width="3" height="9" rx="0.5" fill="none" />
          </g>
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['cabin_lamps'] || ''"
        [attr.data-name]="'interior.cabin_lamp' | translate"
      >
        <rect
          id="Rectangle_38-28"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(826 419)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-31"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 419)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-31"
          data-name="3.0"
          transform="translate(832 434)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <rect
          class="parts"
          id="Cabin_Lamp-2"
          data-name="Cabin Lamp"
          width="22"
          height="5.323"
          rx="1"
          transform="translate(688.342 396.339)"
          fill="#f9b22a"
        />
        <text
          id="Cabin_Lamp-3"
          data-name="Cabin Lamp"
          transform="translate(854 435)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'interior.cabin_lamp' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-21" data-name="Arrow">
          <path
            id="Path_151"
            data-name="Path 151"
            d="M6157,979.656l97.132,33.339H6278"
            transform="translate(-5452 -583.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_152"
            data-name="Path 152"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(702 393)"
            fill="#696969"
          />
        </g>
      </g>
    </g>
  </svg>

  <loader [position]="{ absolute: true }" [active]="loaded"></loader>
</div>

<!-- Modal -->
<ng-template #condition>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>
    <button type="button" class="close" (click)="modalRef.hide()">
      <i class="bi bi-x"></i>
    </button>
  </div>
  <form
    class="condition__form credential"
    [formGroup]="conditionForm"
    (submit)="saveConditionState()"
  >
    <div class="modal-body conditionModal__body h-auto">
      <div class="vam_show_car_form_container">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.condition' | translate
              }}</label>
              <ng-container *ngIf="lang == 'en'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  [readonly]="role === 'evaluator' || role === 'purchasemanager'"
                >
                </ng-select>
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  [readonly]="role === 'evaluator' || role === 'purchasemanager'"
                >
                </ng-select>
              </ng-container>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.severity' | translate
              }}</label>
              <!-- start -->
              <select
                class="form-control credential__select-lg"
                formControlName="vpcs_severity"
                [class.is-invalid]="formData.vpcs_severity.invalid && this.submitted"
                [attr.disabled]="true"
              >
                <option value="" disabled="true" selected="true">Select Severity</option>
                <option [value]="1">1 (Part change)</option>
                <option [value]="2">2 (Major Repair)</option>
                <option [value]="3">3 (Moderate Repair)</option>
                <option [value]="4">4 (Minor Repair)</option>
                <option [value]="5">5 (Good part)</option>
              </select>
              <!-- end -->

              <!-- <ng-select
                  name="parts_conditions_id" 
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select Severity"
                  [readonly]="role === 'evaluator' || role === 'purchasemanager'">
                </ng-select> -->
            </div>
          </div>
        </div>

        <!-- <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{ 'condition_modal.description' | translate }}</label>
              <label class="modal_car_input_label">Description</label>
              <textarea class="form-control credential__textarea" formControlName="vpcs_s_dec"
                [class.is-invalid]="formData.vpcs_s_dec.invalid && this.submitted"
                [readonly]="role === 'evaluator' || role === 'purchasemanager'"></textarea>
            </div>
          </div>
        </div> -->

        <div class="row mb-3 d-none">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.labour_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_lb_cost"
                formControlName="vpcs_lb_cost"
                [class.is-invalid]="formData.vpcs_lb_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #labourCost
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.parts_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_prt_cost"
                formControlName="vpcs_prt_cost"
                [class.is-invalid]="formData.vpcs_prt_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #partsCost
              />
            </div>
          </div>
        </div>

        <div class="row mb-3 d-none">
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.cost_of_repair' | translate
              }}</label>
              <input
                type="text"
                name="vpcs_rp_cost"
                formControlName="vpcs_rp_cost"
                class="form-control credential__input-lg"
                [class.is-invalid]="formData.vpcs_rp_cost.invalid && this.submitted"
                [value]="+labourCost.value + +partsCost.value || ''"
                readonly
              />
            </div>
          </div>
        </div>

        <!-- Before image start -->
        <div class="row mx-n2" *ngIf="imageOld['beforeImg1'] || imageOld['beforeImg2']">
          <!-- Show label only if both Before & After images exist -->
          <div
            class="col-12 px-2"
            *ngIf="
              (imageOld['beforeImg1'] || imageOld['beforeImg2']) &&
              (imageNew['afterImg1'] || imageNew['afterImg2'])
            "
          >
            <label class="credential__label">
              {{ 'condition_modal.before' | translate }}
            </label>
          </div>

          <!-- 1st image -->
          <div class="col-md-6 px-2" *ngIf="imageOld['beforeImg1']">
            <div class="form-group position-relative">
              <label class="credential__file">
                <img [src]="imageOld['beforeImg1']" class="conditionFormFilePreview" />
              </label>
              <div class="upload-actions">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  (click)="openViewer(imageOld['beforeImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- 2nd image -->
          <div class="col-md-6 px-2" *ngIf="imageOld['beforeImg2']">
            <div class="form-group position-relative">
              <label class="credential__file">
                <img [src]="imageOld['beforeImg2']" class="conditionFormFilePreview" />
              </label>
              <div class="upload-actions">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  (click)="openViewer(imageOld['beforeImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Before image end -->

        <!-- After image start -->
        <div class="row mx-n2" *ngIf="imageNew['afterImg1'] || imageNew['afterImg2']">
          <!-- Show label only if BOTH After & Before images exist -->
          <div
            class="col-12 px-2"
            *ngIf="
              (imageNew['afterImg1'] || imageNew['afterImg2']) &&
              (imageOld['beforeImg1'] || imageOld['beforeImg2'])
            "
          >
            <label class="credential__label">
              {{ 'condition_modal.after' | translate }}
            </label>
          </div>

          <!-- For 1st image -->
          <div class="col-md-6 px-2" *ngIf="imageNew['afterImg1']">
            <div class="form-group position-relative">
              <label class="credential__file">
                <img [src]="imageNew['afterImg1']" class="conditionFormFilePreview" />
              </label>
              <div class="upload-actions">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  (click)="openViewer(imageNew['afterImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- For 2nd image -->
          <div class="col-md-6 px-2" *ngIf="imageNew['afterImg2']">
            <div class="form-group position-relative">
              <label class="credential__file">
                <img [src]="imageNew['afterImg2']" class="conditionFormFilePreview" />
              </label>
              <div class="upload-actions">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  (click)="openViewer(imageNew['afterImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- After image end -->
      </div>

      <loader [position]="{ absolute: true }" [active]="partConditionLoaded"></loader>
    </div>
  </form>
</ng-template>
